export default __webpack_public_path__ + "static/newsletter-green-background-b9c87c87b6f5a48d943e449483f21c9e.mp4";